<template>
	<div id="app">
		<div class="page-wrapper">
			<Header/>
			<div class="page-main" role="main">
				<div class="content-wrapper container">
					<Modal v-if="bidResult"/>
					<BetForm v-else/>
				</div>
			</div>
			<Footer/>
		</div>
	</div>
</template>

<script>
	import Header from "./components/Header";
	import Footer from "./components/Footer";
	import BetForm from "./components/BetForm";
	import Modal from "./components/Modal";
	import {mapState} from 'vuex'

	export default {
		name:       "app",
		components: {
			BetForm, Modal, Footer, Header
		},
		computed:   {
			...mapState({
				bidResult: state => state.indexes.bidResult
			})
		}
	};
</script> 
<style lang="scss">
	@import './assets/styles/main.scss';
</style>
